import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';

import useShipmentTrackingData from './useShipmentTrackingData';
import pushStat, { configureStats } from './pushStat';
import productionPreviewMockData from './productionPreviewData'; // DO NOT CHANGE THIS IMPORT. USED BY PREVIEW FROM SHIP-IT

import ErrorBoundary from './ErrorBoundary';
import TrackingPage from './TrackingPage';
import DevControls from './DevControls';


export default function App({ testData }) {
  const url = new URL(window.location.href);
  const isPreviewMode = url.searchParams.get('preview');
  const mockPreviewData = testData
    || (isPreviewMode && productionPreviewMockData);

  const [data,setData] = useShipmentTrackingData({
    id: url.searchParams.get('d'),
    isPreview: !!mockPreviewData,
    mockPreviewData,
  });

  if (url.searchParams.get('mockShipment')) {
    data.shipment = productionPreviewMockData.shipment;
    data.tracking = productionPreviewMockData.tracking;
  }

  useEffect(() => {
    if( data.branding && data.shipment && !mockPreviewData ) {
      configureStats({
        isPreview: !!mockPreviewData,
        customer_id: data.shipment.external_account_id || (data.tracking && data.tracking.customer_id),
        branded_tracking_config_id: data.branding.branded_tracking_config_id,
        tracking_number: data.shipment.tracking_number,
        carrier_code: data.shipment.carrier_code,
        buyer_email: data.shipment.destination.email,
      });
      pushStat('view');
    }
  }, [data, data.tracking, data.branding, data.shipment, mockPreviewData]);

  if (data.loaded === true && (!data.shipment || Object.keys(data.branding).length === 0)) {
    if (!data.shipment) {
      Sentry.captureMessage('Shipment missing.');
    }

    if (Object.keys(data.branding).length === 0) {
      Sentry.captureMessage('Branding missing.');
    }

    const { carrier_tracking_url } = data;
    window.location = carrier_tracking_url;
    return null;
  }

  return <ErrorBoundary data={data}>
    <TrackingPage data={data} />
    <DevControls { ...{ data, setData } } />
  </ErrorBoundary>;
}
App.propTypes = {
  testData: PropTypes.object
};
